export default "__VITE_PUBLIC_ASSET__4410d90c__"